import React from "react";
import { Box, HStack, Text, Image, Container } from "@chakra-ui/react";
import { FiArrowLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import Header from "components/reusables/Header/Header";
import Footer from "components/includes/Footer/Footer";
import ServiceMenu from "components/ServiceMenu/ServiceMenu";
import { bharatConnect } from "assets/images";
type Props = {
  title: string;
  backTo?: string; // if given, go there
  children: React.ReactNode;
};

export const BbpsComplainLayout: React.FC<Props> = ({
  title,
  backTo,
  children,
}) => {
  const navigate = useNavigate();

  const onBack = () => {
    if (backTo) navigate(backTo);
    else navigate(-1);
  };

  return (
    <>
      <Header />
      <Box pt="65px">
        <ServiceMenu />
        <Box bg="gray.50" minH="70vh" py={{ base: 2, md: 4 }}>
          <Container>
            <Box
              bg="white"
              // borderWidth="1px"
              // borderColor="blackAlpha.100"
              rounded="xs"
              shadow="xs"
            >
              {/* Header */}
              <HStack
                px={4}
                py={3}
                justify="space-between"
                borderBottomWidth="1px"
                borderColor="blackAlpha.100"
              >
                <HStack gap={3} cursor="pointer" onClick={onBack}>
                  <Box as={FiArrowLeft} />
                  <Text fontWeight="semibold" color="gray.800">
                    {title}
                  </Text>
                </HStack>
                <Image
                  src={bharatConnect}
                  alt="BBPS Logo"
                  h={["20px", "30px", "40px"]}
                />
              </HStack>

              <Box p={4}>{children}</Box>
            </Box>
          </Container>
        </Box>
      </Box>
      <Footer />
    </>
  );
};
